import {
  Divider,
  Drawer,
  Form,
  Input,
  InputNumber,
  Select,
  Spin,
  Table,
} from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import svg10 from "../../assets/svg/svg10.svg";
import svg23 from "../../assets/svg/svg23.svg";
import svg24 from "../../assets/svg/svg24.svg";
import svg25 from "../../assets/svg/svg25.svg";
import svg26 from "../../assets/svg/svg26.svg";
import { fetchData } from "../../features/fetch/fetchSlice";
import toast from "react-hot-toast";
import TableLoading from "../../components/TableLoading";
import { save } from "../../features/save/saveSlice";

const EditableCell = ({
  editing,
  dataIndex,
  title,
  inputType,
  record,
  index,
  children,
  ...restProps
}) => {
  const inputNode =
    inputType === "money" ? (
      <InputNumber
        prefix={"KES"}
        min={1}
        id="input-focus"
        className="input"
        variant="borderless"
      />
    ) : inputType === "dropdown" ? (
      <Select
        suffixIcon={
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="21"
            height="21"
            viewBox="0 0 21 21"
            fill="none"
          >
            <path
              d="M17.1922 8.21268L10.9422 14.4627C10.8841 14.5208 10.8152 14.5669 10.7393 14.5983C10.6634 14.6298 10.5821 14.646 10.5 14.646C10.4178 14.646 10.3365 14.6298 10.2606 14.5983C10.1848 14.5669 10.1158 14.5208 10.0578 14.4627L3.80779 8.21268C3.69052 8.0954 3.62463 7.93634 3.62463 7.77049C3.62463 7.60464 3.69052 7.44558 3.80779 7.3283C3.92507 7.21103 4.08413 7.14514 4.24998 7.14514C4.41583 7.14514 4.57489 7.21103 4.69217 7.3283L10.5 13.1369L16.3078 7.3283C16.3659 7.27023 16.4348 7.22417 16.5107 7.19274C16.5865 7.16132 16.6679 7.14514 16.75 7.14514C16.8321 7.14514 16.9134 7.16132 16.9893 7.19274C17.0652 7.22417 17.1341 7.27023 17.1922 7.3283C17.2502 7.38637 17.2963 7.45531 17.3277 7.53118C17.3592 7.60705 17.3753 7.68837 17.3753 7.77049C17.3753 7.85261 17.3592 7.93393 17.3277 8.0098C17.2963 8.08567 17.2502 8.15461 17.1922 8.21268Z"
              fill="#212121"
            />
          </svg>
        }
        // options={paymentMethodsData?.map((item, index) => {
        //   return {
        //     label: (
        //       <div key={index}>
        //         <span>{item?.label}</span>
        //       </div>
        //     ),
        //     value: item?.value,
        //   };
        // })}
      />
    ) : (
      <Input id="input-focus" className="input" variant="borderless" />
    );
  return (
    <td {...restProps}>
      {editing ? (
        <Form.Item
          className="table-form-item"
          name={dataIndex}
          style={{
            margin: 0,
          }}
          rules={[
            {
              required: false,
              message: `Field is required`,
            },
          ]}
        >
          {inputNode}
        </Form.Item>
      ) : (
        children
      )}
    </td>
  );
};

export default function SetupView({
  open,
  onClose,
  prodd,
  pageIndex,
  setPageIndex,
  pageSize,
  setPageSize,
  handleFetch,
}) {
  const dispatch = useDispatch();
  const navigate = useNavigate;
  const [form] = Form.useForm();

  const { activeObj } = useSelector((state) => state.obj);
  const { saving } = useSelector((state) => state.save);
  const url = "api/v1/pages/properties";
  const { loading, data, count } = useSelector((state) => ({
    loading: state.fetch.loading,
    data: state.fetch.data[url] || [],
    count: state.fetch.count[url] || 0,
  }));
 
  const [editingKey, setEditingKey] = useState("");
  const [selectedObj, setselectedObj] = useState({});

  const isEditing = (record) => record?.ppId === editingKey;

  const edit = (record) => {
    form.setFieldsValue({
      ...record,
    });
    setEditingKey(record?.ppId);
  };

  const cancel = () => {
    setEditingKey("");
  };

  const saveFunction = async (key) => {
    try {
      const row = await form.validateFields();
      const newData = [...data];
      const index = newData.findIndex((item) => key === item?.ppId);
      if (index > -1) {
        const item = newData[index];

        const updatedObj = {
          ...item,
          ...row,
        };
        const res = await dispatch(
          save({
            pgdPgId: activeObj?.pgId,
            ...updatedObj,
            url: "api/v1/pages/properties/gl-account",
          })
        );
        if (res?.payload?.success) {
          await handleFetch(pageIndex, pageSize, prodd?.pId);
          await toast.success(res?.payload?.messages?.message);
          await setEditingKey("");
        } else {
          toast.error(res?.payload?.messages?.message);
        }
      }
    } catch (errInfo) {
      console.log("Validate Failed:", errInfo);
    }
  };

  const columns = [
    {
      title: "Column",
      dataIndex: "ppColName",
    },
    {
      title: "GL Account",
      dataIndex: "ppGlAccount",
      editable: true,
    },

    {
      title: "Action",
      dataIndex: "operation",
      render: (_, record) => {
        const editable = isEditing(record);
        return editable ? (
          <div className="flex w-fit items-center gap-[1rem]">
            <img onClick={cancel} src={svg25} alt="svg25" />
            {saving ? (
              <Spin className="blu_spin" />
            ) : (
              <img
                onClick={() => saveFunction(record?.ppId)}
                src={svg26}
                alt="svg26"
              />
            )}
          </div>
        ) : (
          <img src={svg10} alt="svg10" onClick={() => edit(record)} />
        );
      },
    },
  ];

  const mergedColumns = columns.map((col) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record) => ({
        record,
        dataIndex: col.dataIndex,
        inputType:
          col.dataIndex === "pgdPaymentMode"
            ? "dropdown"
            : col.dataIndex === "pgdAmount"
            ? "money"
            : "text",
        title: col.title,
        editing: isEditing(record),
      }),
    };
  });

  return (
    <Drawer
      width={1100}
      title={null}
      open={open}
      onClose={onClose}
      closable={false}
      maskClosable={false}
    >
      <div className="sticky top-0 z-20 bg-white pb-2">
        <div className="pt-[2.5rem] px-[2.5rem] flex items-center justify-between">
          <div className="flex gap-[1.25rem]">
            <div className="rounded-[.25rem] bg-[#D6E1F5] h-[3rem] w-[3rem] flex items-center justify-center">
              <img src={svg23} alt="svg23" />
            </div>
            <div className="flex flex-col">
              <span className="typography_3">{`${prodd?.pName} Gl Setup`}</span>
              <span className="typography">
                Click the edit action to change the information.
              </span>
            </div>
          </div>

          <img
            src={svg24}
            alt="close"
            onClick={onClose}
            className="cursor-pointer"
          />
        </div>
        <Divider />
      </div>

      <div className="px-[2.5rem]">
        {loading ? (
          <TableLoading />
        ) : (
          <Form form={form} component={false}>
            <Table
              rowSelection={false}
              className="gl-account"
              components={{
                body: {
                  cell: EditableCell,
                },
              }}
              rowKey={"ppId"}
              dataSource={data}
              columns={mergedColumns}
              scroll={{
                x: "auto",
              }}
              pagination={false}
            />
          </Form>
        )}
      </div>
    </Drawer>
  );
}
